import flatpickr from 'flatpickr';
import { getUkNowParts } from './helpers';

let picker, ceremonyPicker;

// todo - define dates for weddings vs other order types

const closedDates = window.SDE.closedDates || [];
const overrideDates = window.SDE.overrideDates || [];
const openDays = window.SDE.openDays || [];
const cutoffHour = window.SDE.cutoffHour || 10;
const cutoffMinute = window.SDE.cutoffMinute || 0;
const datePickerElement = '#date-required';
const ceremonyDatePickerElement = '#ceremony-date';

const removeFromCart = ( key ) => {
  fetch('/cart/change.js', {
    method: 'POST',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(
      {
        'id': key,
        'quantity': 0,
      },
    ),
  }).then(() => {
    location.reload();
  });
};

document.addEventListener('vs:updatedCart', ( cart ) => {
  const simpleCart = document.getElementById('cart-simple');
  const smallWedding = document.getElementById('cart-sw');
  let has_sub = false;
  let has_sub_only_prop = false;
  const keys = [];
  cart.detail.cart.items.forEach(item => {
    if (!!item.selling_plan_allocation) {
      has_sub = true;
    }
    if (!!item.properties['__sub-only'] && item.properties['__sub-only'] === true) {
      has_sub_only_prop = true;
      keys.push(item.key);
    }
  });
  if (!has_sub && has_sub_only_prop) {
    keys.forEach(key => removeFromCart(key));
  }
  populateStoredColorPrefs();

  if (smallWedding?.value === 'true') {
    checkSwValid();
  }
  if ((simpleCart?.value === 'true') || (smallWedding?.value === 'false')) {
    checkValid();
  }
  initListeners();
});

const setDeliveryOptions = () => {
  document.getElementById('cart-time-required').style.display = 'none';
  checkValid();
};

const setCollectionOptions = () => {
  document.getElementById('cart-time-required').style.display = 'flex';
  checkValid();
};

const setSwDeliveryOptions = () => {
  document.getElementById('cart-time-required').style.display = 'none';
  checkSwValid();
};

const setSwCollectionOptions = () => {
  document.getElementById('cart-time-required').style.display = 'flex';
  checkSwValid();
};

const storeText = ( evt ) => {
  localStorage.setItem('sd-colour-pref', evt.target.value);
};

const getWeeksDiff = ( startDate, endDate ) => {
  const msInWeek = 1000 * 60 * 60 * 24 * 7;
  return Math.round(Math.abs(endDate - startDate) / msInWeek);
};

const paymentOptionsHtml = () => {
  const div = document.createElement('div');
  const fieldset = document.createElement('fieldset');
  const legend = document.createElement('legend');
  const rad1 = document.createElement('input');
  const label1 = document.createElement('label');
  const rad2 = document.createElement('input');
  const label2 = document.createElement('label');
  const br = document.createElement('br');
  const inputEl = document.createElement('input');
  div.className = 'field';
  fieldset.className = 'js payment-options';
  legend.className = 'form__label';
  legend.innerText = 'Payment options';
  rad1.type = 'radio';
  rad1.name = 'attributes[Payment]';
  rad1.value = 'In Full';
  rad1.id = 'payment-full';
  rad1.setAttribute('form', 'cart');
  label1.setAttribute('for', 'payment-full');
  label1.innerText = 'Pay in full today';
  rad2.type = 'radio';
  rad2.name = 'attributes[Payment]';
  rad2.value = 'Booking Fee';
  rad2.id = 'payment-booking';
  rad2.setAttribute('form', 'cart');
  label2.setAttribute('for', 'payment-booking');
  label2.innerText = 'Pay 20% booking fee';
  inputEl.type = 'hidden';
  inputEl.name = 'discount';
  inputEl.id = 'discount';
  inputEl.value = '';
  inputEl.setAttribute('form', 'cart');
  div.appendChild(fieldset);
  fieldset.appendChild(legend);
  fieldset.appendChild(rad1);
  fieldset.appendChild(label1);
  fieldset.appendChild(br);
  fieldset.appendChild(rad2);
  fieldset.appendChild(label2);
  div.appendChild(inputEl);
  return div;
};

const populateStoredColorPrefs = () => {
  const colorPrefs = document.getElementById('colour-preferences');
  if (!!colorPrefs) {
    const currentPref = localStorage.getItem('sd-colour-pref');
    if (currentPref?.length > 0) {
      colorPrefs.value = currentPref;
    }
  }
};

const sdAugmentCart = ( evt ) => {
  const payFullRadio = document.getElementById('payment-full');
  const payBookingRadio = document.getElementById('payment-booking');
  if (payFullRadio?.checked === false && payBookingRadio?.checked === false) {
    evt.preventDefault();
  }
  else {
    const discountEl = document.getElementById('discount');
    if (payBookingRadio?.checked) {
      discountEl.value = 'BOOKINGFEE';
    }
    else {
      if (!!discountEl) {
        discountEl.value = '';
      }
    }
  }
};

const checkSwValid = () => {
  const deliveryOption = document.getElementById('cart-delivery');
  const collectionOption = document.getElementById('cart-collection');
  const timeRequiredInput = document.getElementById('time-required');
  const ceremonyDateInput = document.getElementById('ceremony-date');
  const ceremonyTimeInput = document.getElementById('ceremony-time');

  const targetDateValue = picker?.selectedDates[0];

  const today = new Date();
  const weeks = getWeeksDiff(Date.parse(today.toISOString().split('T')[0]),
    targetDateValue);
  document.getElementById('payment-options__wrapper').innerText = '';
  if (weeks >= 6) {
    document.getElementById('payment-options__wrapper').appendChild(paymentOptionsHtml());
  }
  const deliveryValid = deliveryOption?.checked && picker?.selectedDates[0] && ceremonyPicker?.selectedDates[0] && ceremonyTimeInput?.value !== '';
  const collectionValid = collectionOption?.checked && picker?.selectedDates[0] &&
    timeRequiredInput?.value !== '' && ceremonyPicker?.selectedDates[0] && ceremonyTimeInput?.value !== '';
  document.getElementById('checkout').disabled = !(deliveryValid || collectionValid);
};

const checkValid = () => {
  const deliveryOption = document.getElementById('cart-delivery');
  const collectionOption = document.getElementById('cart-collection');
  const timeRequiredInput = document.getElementById('time-required');
  const simpleCart = document.getElementById('cart-simple');
  const checkoutButton = document.getElementById('checkout');

  if (!!checkoutButton) {
    if (simpleCart?.value === 'true') {
      checkoutButton.disabled = false;
      return;
    }
    if (deliveryOption?.checked) {
      if (picker?.selectedDates[0]) {
        checkoutButton.disabled = false;
        return;
      }
      else {
        checkoutButton.disabled = true;
      }
    }
    if (collectionOption?.checked) {
      if (picker?.selectedDates[0] && timeRequiredInput.value) {
        checkoutButton.disabled = false;
        return;
      }
      else {
        checkoutButton.disabled = true;
      }
    }
    checkoutButton.disabled = true;
  }
};

const enableDatePicker = () => {
  const deliveryOption = document.getElementById('cart-delivery');
  const simpleCart = document.getElementById('cart-simple');
  const smallWedding = document.getElementById('cart-sw');
  const dateElement = document.getElementById('date-required');

  initPicker();
  dateElement.disabled = false;
  if ((simpleCart?.value === 'false') || (smallWedding?.value === 'false')) {
    const deliveryOrder = blockSundays();
    if (!!deliveryOption) {
      picker.set('disable', [
        ( date ) => {
          const currentDate = flatpickr.formatDate(date, 'Y-m-d');
          if (deliveryOrder) {
            const dayName = flatpickr.formatDate(date, 'l').toLowerCase();
            return !overrideDates.includes(currentDate) && !openDays.includes(dayName);
          }
          else {
            return false;
          }
        },
      ]);
      picker.set('onChange', checkValid);
    }
  }
  if (smallWedding?.value === 'true') {
    if (!!deliveryOption) {
      picker.set('disable', [
        ( date ) => {
          const currentDate = flatpickr.formatDate(date, 'Y-m-d');
          return closedDates.includes(currentDate);
        },
      ]);
      picker.set('onChange', checkSwValid);
    }
  }
};

const initListeners = () => {
  const colorPrefs = document.getElementById('colour-preferences');
  const deliveryOption = document.getElementById('cart-delivery');
  const collectionOption = document.getElementById('cart-collection');
  const timeRequiredInput = document.getElementById('time-required');
  const simpleCart = document.getElementById('cart-simple');
  const smallWedding = document.getElementById('cart-sw');
  const dateElement = document.getElementById('date-required');
  const checkoutButton = document.getElementById('checkout');
  const ceremonyDateInput = document.getElementById('ceremony-date');
  const ceremonyTimeInput = document.getElementById('ceremony-time');

  if (!!colorPrefs) {
    colorPrefs.addEventListener('change', storeText);
    populateStoredColorPrefs();
  }

  if (simpleCart?.value === 'true') {
    checkoutButton.disabled = true;
    checkValid();
  }

  if (smallWedding?.value === 'true') {
    if (!!deliveryOption) {
      deliveryOption.removeEventListener('click', setDeliveryOptions);
      collectionOption.removeEventListener('click', setCollectionOptions);
      timeRequiredInput.removeEventListener('change', checkValid);

      deliveryOption.addEventListener('click', setSwDeliveryOptions);
      collectionOption.addEventListener('click', setSwCollectionOptions);
      timeRequiredInput.addEventListener('change', checkSwValid);
      ceremonyDateInput?.addEventListener('change', checkSwValid);
      ceremonyTimeInput?.addEventListener('change', checkSwValid);
    }
    document.getElementById('cart').removeEventListener('submit', sdAugmentCart);
    document.getElementById('cart').addEventListener('submit', sdAugmentCart);

    const perfEntries = performance.getEntriesByType('navigation');
    if (perfEntries.length && perfEntries[0].type === 'back_forward') {
      setTimeout(() => {
        checkSwValid();
      }, 0);
    }
    checkSwValid();
  }
  if ((simpleCart?.value === 'false') || (smallWedding?.value === 'false')) {
    if (!!deliveryOption) {
      deliveryOption.removeEventListener('click', setSwDeliveryOptions);
      collectionOption.removeEventListener('click', setSwCollectionOptions);
      timeRequiredInput.removeEventListener('change', checkSwValid);
      ceremonyDateInput?.removeEventListener('change', checkSwValid);
      ceremonyTimeInput?.removeEventListener('change', checkSwValid);

      deliveryOption.addEventListener('click', setDeliveryOptions);
      collectionOption.addEventListener('click', setCollectionOptions);
      timeRequiredInput.addEventListener('change', checkValid);
    }
    document.getElementById('cart').removeEventListener('submit', sdAugmentCart);
    checkValid();
  }

  if (!!dateElement) {
    dateElement.disabled = deliveryOption?.checked !== true && collectionOption?.checked !== true;
  }
  deliveryOption?.addEventListener('click', enableDatePicker);
  collectionOption?.addEventListener('click', enableDatePicker);
};

const getMinDate = () => {
  const deliveryOption = document.getElementById('cart-delivery');
  const shopTime = getUkNowParts();
  const minDate = new Date(shopTime.year, shopTime.month - 1, shopTime.day);
  if (deliveryOption?.checked) {
    const currentHour = shopTime.hour;
    const currentMinute = shopTime.minute;
    const afterCutoff = currentHour > cutoffHour ||
      (currentHour === cutoffHour && currentMinute >= cutoffMinute);
    if (afterCutoff) {
      minDate.setDate(minDate.getDate() + 1);
    }
    return minDate;
  }
  return minDate;
};

const blockSundays = () => {
  const collectionOption = document.getElementById('cart-collection');
  return !collectionOption?.checked;
};

const initPicker = () => {
  const minDate = getMinDate();
  picker = flatpickr(datePickerElement, {
    dateFormat: 'd/m/Y',
    disableMobile: true,
    locale: {
      firstDayOfWeek: 1,
    },
    minDate: minDate,
  });
};

const init = () => initListeners();

const initCeremonyPicker = () => {
  if(!!ceremonyDatePickerElement) {
    ceremonyPicker = flatpickr(ceremonyDatePickerElement, {
      dateFormat: 'd/m/Y',
      disableMobile: true,
      locale: {
        firstDayOfWeek: 1,
      }
    });
    ceremonyPicker.set('onChange', checkSwValid);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    init();
    initCeremonyPicker();
  });
}
else {
  init();
  initCeremonyPicker();
}

